/**
 * ALLES GEREGELT — Public Pre-Launch Landingpage · Stage 1
 * Zentrale Content-Datei. Ein Ort für alle Texte.
 * Änderungen hier wirken sofort in allen Landingpage-Komponenten.
 */

export const landing = {
  navigation: {
    items: [
      { id: "story", label: "Was ist ALLES GEREGELT?" },
      { id: "lebensbaum", label: "Lebensbaum" },
      { id: "vertrauenskarte", label: "Vertrauenskarte" },
      { id: "lina", label: "LINA" },
    ],
    loginLabel: "Login",
    loginHref: "/login",
    menuOpen: "Menü öffnen",
    menuClose: "Menü schließen",
  },

  hero: {
    headline: "Man kann das Leben nicht planen. Aber man kann vorbereitet sein.",
    subline: "Was wäre, wenn morgen plötzlich jemand anderes alles regeln müsste?",
    description:
      "ALLES GEREGELT bringt die wichtigen Dinge des Lebens an einen Ort – übersichtlich, persönlich und für die Menschen, die Ihnen wichtig sind.",
    ctaPrimary: "Von Anfang an dabei sein",
    ctaPrimaryHref: "#waitlist",
    ctaSecondary: "Film ansehen",
    ctaSecondaryHref: "#hero-video",
    claim: "Ein gutes Gefühl. Weil alles geregelt ist.",
    overline: "ALLES GEREGELT",
    videoPlaceholder: "Film in Kürze verfügbar.",
  },

  brandMessage: {
    manifest: "Sie kaufen keine Software. Sie kaufen das gute Gefühl, dass alles geregelt ist.",
    platform: "Ihre digitale Vertrauensplattform fürs Leben.",
    pillars: "Lebensbaum, Vertrauensring und Dokumententresor \u2013 übersichtlich an einem Ort.",
  },

  story: {
    headline: "Das Leben besteht nicht aus Ordnern.",
    intro:
      "Es besteht aus Menschen, aus Momenten, aus Verantwortung — und aus vielen kleinen Dingen, die im Ernstfall plötzlich zählen.",
    items: [
      { key: "dokumente", label: "Dokumente" },
      { key: "familie", label: "Familie" },
      { key: "vorsorge", label: "Vorsorge" },
      { key: "finanzen", label: "Finanzen" },
      { key: "notfall", label: "Notfall" },
      { key: "wuensche", label: "Wünsche" },
    ],
  },

  lifeTree: {
    headline: "Ihr Leben. Auf einen Blick.",
    text:
      "Der Lebensbaum macht sichtbar, welche wichtigen Lebensbereiche bereits geregelt sind — und wo noch etwas Aufmerksamkeit sinnvoll sein könnte.",
    hint: "Nicht alles auf einmal. Sondern Schritt für Schritt.",
    demoAreas: [
      { name: "Gesundheit", progress: 82, tone: "primary" },
      { name: "Familie", progress: 74, tone: "primary" },
      { name: "Vorsorge", progress: 65, tone: "primary" },
      { name: "Finanzen", progress: 58, tone: "muted" },
      { name: "Notfall", progress: 46, tone: "muted" },
      { name: "Wünsche", progress: 32, tone: "muted" },
    ],
  },

  trustRing: {
    headline: "Wie gut ist eigentlich alles geregelt?",
    text:
      "Der Vertrauensring gibt Orientierung und macht sichtbar, wo bereits viel geregelt ist und wo noch etwas Aufmerksamkeit sinnvoll sein könnte.",
    quote: "Es geht nicht um 100 %. Es geht um das gute Gefühl, angefangen zu haben.",
    demoValue: 68,
    dimensions: [
      { key: "vollstaendigkeit", label: "Vollständigkeit", value: 72 },
      { key: "aktualitaet", label: "Aktualität", value: 63 },
      { key: "sicherheit", label: "Sicherheit", value: 81 },
      { key: "notfallbereitschaft", label: "Notfallbereitschaft", value: 56 },
    ],
  },

  trustCard: {
    headline: "Wenn jemand helfen muss, zählt Klarheit.",
    text:
      "Mit der Vertrauenskarte können ausgewählte Informationen über einen persönlichen QR-Zugang bereitgestellt werden.",
    hint: "Sie bestimmen, welche Informationen freigegeben werden.",
    features: [
      "Nur freigegebene Informationen sind sichtbar",
      "Jeder Zugriff wird protokolliert",
      "Die Karte lässt sich jederzeit sperren",
    ],
  },

  people: {
    headline: "Für die Menschen, die Ihnen wichtig sind.",
    items: [
      {
        key: "kinder",
        title: "Für Ihre Kinder",
        text: "Damit sie im Zweifel wissen, was Sie sich gewünscht hätten.",
      },
      {
        key: "partner",
        title: "Für Ihren Partner oder Ihre Partnerin",
        text: "Damit im Ernstfall nicht plötzlich alles allein zu tragen ist.",
      },
      {
        key: "eltern",
        title: "Für Ihre Eltern",
        text: "Damit auch die andere Generation eingebunden bleibt.",
      },
      {
        key: "sich",
        title: "Für sich selbst",
        text: "Damit das gute Gefühl im Alltag mitgeht.",
      },
    ],
    closing:
      "Wir regeln die Dinge nicht, weil wir etwas Schlimmes erwarten. Sondern weil uns das Leben wichtig ist.",
  },

  lina: {
    headline: "Hallo, ich bin LINA.",
    text: "Ich werde Sie bei ALLES GEREGELT Schritt für Schritt begleiten.",
    status: "LINA kommt bald.",
    note: "Bis dahin führen wir Sie ruhig durch jede wichtige Frage.",
  },

  platform: {
    headline: "Wir sind weiter als eine Idee.",
    intro: "ALLES GEREGELT wird bereits entwickelt.",
    body:
      "Lebensbaum, Vertrauensring, Dokumentenbereich, Aufgaben, Familie, Vertrauenspersonen und Notfallzugang sind bereits Bestandteil der Plattform.",
    closing:
      "Aktuell bereiten wir ALLES GEREGELT Schritt für Schritt auf den öffentlichen Start vor.",
    screenshots: [
      { key: "dashboard", label: "Dashboard" },
      { key: "lebensbaum", label: "Lebensbaum" },
      { key: "vault", label: "Dokumentenbereich" },
      { key: "trustcard", label: "Vertrauenskarte" },
    ],
  },

  waitlist: {
    headline: "Von Anfang an dabei sein.",
    text: "Wir bereiten ALLES GEREGELT derzeit auf den Start vor.",
    subtext:
      "Erfahren Sie als einer der Ersten, wenn wir erste Testmöglichkeiten öffnen und ALLES GEREGELT startet.",
    emailLabel: "E-Mail-Adresse",
    emailPlaceholder: "ihre@e-mail.de",
    consentLabel:
      "Ich möchte informiert werden, sobald ALLES GEREGELT startet. Meine E-Mail-Adresse wird ausschließlich zu diesem Zweck verarbeitet.",
    consentPrivacyPrefix: "Weitere Informationen in unserer ",
    consentPrivacyLabel: "Datenschutzerklärung",
    consentPrivacyHref: "/datenschutz",
    submitLabel: "Ich möchte dabei sein",
    submittingLabel: "Wird gesendet …",
    successHeadline: "Fast geschafft.",
    successText:
      "Wenn die Adresse für die Anmeldung verwendet werden kann, erhalten Sie eine E-Mail mit den nächsten Schritten. Bitte prüfen Sie auch Ihren Spam-Ordner.",
    errorText:
      "Anmeldung derzeit nicht möglich. Bitte versuchen Sie es später erneut.",
    consentRequired: "Bitte bestätigen Sie die Einwilligung.",
    emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
    honeypotLabel: "Bitte dieses Feld leer lassen.",
  },

  footer: {
    claim: "Ein gutes Gefühl. Weil alles geregelt ist.",
    links: [
      { label: "Impressum", href: "/impressum" },
      { label: "Datenschutz", href: "/datenschutz" },
      { label: "Sicherheit", href: "/sicherheit" },
      { label: "Login", href: "/login" },
    ],
    copyright: "© ALLES GEREGELT",
  },
};

export default landing;
